import { ApiContext } from '@sleepstation/components-context'
import DbasQuestionnaire from '@sleepstation/components-dbas-questionnaire'
import { FormWrapper } from '@sleepstation/components-form'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import { joinWithComma, replaceTokens } from '@sleepstation/utils'
import React, { useContext } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { getObfuscatedDbasIds } from '../../helpers/quiz'
import PortalPage from '../pages/PortalPage'
import OptionsFullWidthBreakoutModule from '../shared/breakoutModules/OptionsFullWidthBreakoutModule'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const ACTION_URL_TEMPLATE = `#{url}?score=#{score}&qs=#{questionsScoringHighObfuscated}`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getUrl = replaceTokens(ACTION_URL_TEMPLATE)

const navigateToResultsPage = ({
  url,
  score,
  questionsScoringHigh,
  navigate,
}) => {
  const obfuscatedIds = getObfuscatedDbasIds(questionsScoringHigh)
  const questionsScoringHighObfuscated = joinWithComma(obfuscatedIds)

  const urlWithParams = getUrl({
    url,
    score,
    questionsScoringHighObfuscated,
  })

  navigate(urlWithParams)
}

const handleSuccess =
  (url, patchQuizData, navigate) =>
  ({ score, questionsScoringHigh, userData }) => {
    patchQuizData({ userData, score, quizName: `dbas` })
    navigateToResultsPage({ url, score, questionsScoringHigh, navigate })
  }

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalQuizWhatDoYouKnowAboutSleepQuizQuestionsModule = () => {
  const navigate = useNavigate()
  const data = useLoaderData()
  const api = useContext(ApiContext)

  const { portal } = data

  const resultsUrl = portal.helpers.getPath(
    `/portal/what-do-you-know-about-sleep/results/`
  )

  return (
    <PortalPage
      data={data}
      showHeader={false}
      showFooter={false}
      shouldOffsetContent={false}
    >
      <OptionsFullWidthBreakoutModule>
        <ThemeProvider theme={defaultDarkerTheme}>
          <FormWrapper
            wrappedComponent={DbasQuestionnaire}
            onSuccess={handleSuccess(
              resultsUrl,
              portal.api.patchQuizData(api),
              navigate
            )}
          />
        </ThemeProvider>
      </OptionsFullWidthBreakoutModule>
    </PortalPage>
  )
}

export default PortalQuizWhatDoYouKnowAboutSleepQuizQuestionsModule
